export default {
  storageKeys: {
    AUTH_TOKEN: 'auth-token',
    LOGIN_REDIRECT_URL: 'login-redirect-url',
  },
};
